export default {
    preloaded: "app.preload",
    loaded: "app.preloaded",
    notify: "app.notify",
    language: "app.language",
    sounds: "app.sounds",
    jackpots: "app.jackpots",
    jackpots_update: "app.jackpots.update"
}